import axios, { AxiosError } from 'axios';
import axiosRetry from 'axios-retry';

const axiosClient = axios.create({
    baseURL:
        // @ts-expect-error - environment variables lives within the window object
        window?.env?.REACT_APP_FPG_REDIRECT_ENDPOINT && window?.env?.REACT_APP_INCENTIVE_BASE_URL
            ? // @ts-expect-error - environment variables lives within the window object
              window?.env?.REACT_APP_FPG_REDIRECT_ENDPOINT +
              // @ts-expect-error - environment variables lives within the window object
              window?.env?.REACT_APP_INCENTIVE_BASE_URL
            : 'https://dev.fordpro.com/proxy-api-request/?redirect=https://api-dev.fordpro.com/zappyride',
});
axiosRetry(axiosClient, {
    retries: 2,
    retryDelay: (retryCount: number) => {
        console.debug('Retrying for the-->', retryCount, 'time');
        return Math.pow(2, retryCount) * 1000;
    },
    retryCondition: (error: AxiosError) => {
        console.debug('Request failed, retrying again, error is-->', error);
        return Boolean(error?.response && error?.response.status >= 500);
    },
});

export default axiosClient;
